import { render, staticRenderFns } from "./SystemSidebar.vue?vue&type=template&id=31e749ae&"
import script from "./SystemSidebar.vue?vue&type=script&lang=js&"
export * from "./SystemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports